import React, { useState, useEffect } from 'react'
import { setSecurePageRedirect } from '../../../global/authentication/url-redirector.js'
import { getUrlParameter } from '../../../global/data/url.js'
import { STATUS_SUCCESS } from '../../../components/AlertBanner/Constants.js'
import { showAlertBanner } from '../../../components/AlertBanner/index.js'
import LoginPage from '../../../components/Login/Login.jsx'
import {
  generateUID,
  addTMXScriptToBody,
} from '../../utility/threatMetrix/TMX.js'

export const AdvisorLogin = () => {
  const [tmxId, setTmxId] = useState()
  const showPopup = () => {
    if (getUrlParameter('forgotPassword')) {
      showAlertBanner({
        status: STATUS_SUCCESS,
        title: 'You have successfully changed your password.',
        text: 'Use your new password to log in.',
        sticky: true,
      })
    }

    if (getUrlParameter('internalForgotPassword')) {
      showAlertBanner({
        status: STATUS_SUCCESS,
        title: 'After changing your password on the SSO page, ',
        text: 'log in with your new password below.',
        sticky: true,
      })
    }

    if (getUrlParameter('timeout')) {
      setSecurePageRedirect('/')
      showAlertBanner({
        status: STATUS_SUCCESS,
        title: ' For your protection, ',
        text: 'we have logged you out of your account. To access your account, please log in again.',
        sticky: true,
      })
    }

    if (getUrlParameter('logout')) {
      showAlertBanner({
        status: STATUS_SUCCESS,
        title: 'You have successfully logged out. ',
        text: 'Thank you for visiting.',
        sticky: true,
      })
    }
  }

  useEffect(() => {
    addTMXScriptToBodyHandler()
  }, [])

  const addTMXScriptToBodyHandler = async () => {
    const tmx_id = `cti_adv_${generateUID()}`
    showPopup()
    setTmxId(tmx_id)
    await addTMXScriptToBody(tmx_id)
  }

  return <LoginPage tmx_id={tmxId} />
}
